function backOut(element) {
    var mobileNav = document.querySelector(".mobile-site-nav");
    var openSubNav = mobileNav.querySelector(".mobile-site-nav__menu.submenu-open-slideIn");
    var openChildNav = mobileNav.querySelector(".mobile-site-nav__menu.slidein-target-2.submenu-open-slideIn");

    if (openSubNav) {
        if (openChildNav) {
            var openSubNavParent = openChildNav.parentNode;
            openChildNav.classList.remove("submenu-open-slideIn");
            // openChildNav.removeAttribute("style");

        } else {
            var openSubNavParent = openSubNav.parentNode;
            openSubNav.classList.remove("submenu-open-slideIn");
            // openSubNav.removeAttribute("style");
            document.body.classList.remove('sub-menu-open');
        }
    } else {
        var closeElement = document.querySelector(".close-mobile-menu.js-close-mobile-menu");
        document.body.classList.remove('sub-menu-open');
        closeElement.click();
    }
}

$(document).ready(function() {

    const images = document.querySelectorAll('img[data-src]');
    
    const lazyLoadImage = (image) => {
        const src = image.getAttribute('data-src');
        if (src) {
            image.setAttribute('src', src);
            image.removeAttribute('data-src');
            image.style.visibility = 'visible'; 
        }
    };

    const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const image = entry.target;
                lazyLoadImage(image);
                observer.unobserve(image); // Stop observing after the image is loaded
            }
        });
    });

    images.forEach(image => {
        imageObserver.observe(image); // Start observing each image
    });

    $(document).click(function(e) {
        if (e.target.id != 'multilevel-menu' && !$('#multilevel-menu').find(e.target).length && e.target.id != 'shopify-section-header' && !$('#shopify-section-header').find(e.target).length) {
            $("#multilevel-menu nav .new-desktop-menu").hide().removeClass('main-menu-show');
            $(document.body).removeClass('is-menu-open');
            document.querySelector( ".full-page-overlay" ).classList.remove( "overlay-opacity" );
        }
    });

    $(".desktop-new-nav-item-1").click(function(e) {
        $(document.body).toggleClass('is-menu-open');
        $('.full-page-overlay').toggleClass('overlay-opacity');
        $("#multilevel-menu nav > .new-desktop-menu").toggle('show').toggleClass('main-menu-show');
        if ($('.header-nav-vertical li').hasClass('open')) {
            $('.header-nav-vertical li').removeClass('open');
        }
        if (window.screen.width < 968) {
            $('.header-navigation').addClass('header-navigation--open');
        }
    });

    $(".js-close-desktop-menu").click(function() {
        $(document.body).removeClass('is-menu-open');
        $('.full-page-overlay').removeClass('overlay-opacity');
        $(".new-desktop-menu").css("display", "none")
    });

        //top review bar
    if ($('.review-bar-wrap__swiper').length > 0) {
        // Initialize Swiper for the review bar
        var reviewSwiper = new Swiper('.review-bar-wrap__swiper', {
            loop: true,
            slidesPerView: 1,
            centeredSlides: true,
            autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            },
            navigation: false
        });
    }


    $(".mega-dropdown__item, .small-dropdown__item").off().click(function() {
        var mega_nav_id = $(this).attr("data-id");
        $(this).addClass("nav_active").siblings().removeClass("nav_active");
        $(".new-nav-menu--sublinks .site-nav__submenu").each(function() {
            var sub_nav_id = $(this).attr("data-id");
            if (sub_nav_id == mega_nav_id) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    });


    $(document).on('click', '.site-nav__item-back-top', function() {
        const $submenu = $(this).closest('ul').closest('.open-menu');
        const $parentMenu = $submenu.closest('li').closest('ul');
        $parentMenu.children('li').css({ 'display': 'block', 'pointer-events': 'auto' });
        if ($submenu.hasClass('open-menu')) {
            $submenu.removeClass('open-menu').addClass('close-menu');
        }
    });
   
    $('ul.nav.new-desktop-menu > li.site-nav__item-parent').on('click', function() {
        let $submenu = $(this).children('div.first-level-menu');
        if ($submenu.length > 0) {
            $submenu.removeClass('close-menu');
            $submenu.addClass('open-menu'); 
        }
    });

    if (window.screen.width < 968) {
 
        // Handle first-level (to second-level)
        $('li.inner-menu > a').on('click', function (event) {
            const $li = $(this).parent('li');
            const $submenu = $li.children('div.second-level-menu');
            const $parentMenu = $li.closest('div.first-level-menu');

            if ($submenu.length > 0) {
                event.preventDefault();
                event.stopPropagation();

                // Hide sibling <li> items in first-level
                $li.siblings('li').css('display', "none");
                $li.css('display', "block"); // Keep the clicked one visible

                // Optional: prevent pointer events on siblings
                $li.siblings('li').css('pointer-events', 'none');

                // Show submenu
                $parentMenu.removeClass('close-menu');
                $submenu.addClass('open-menu').removeClass('close-menu');
                $submenu.scrollTop(0); 
            }
        });

        // Handle second-level (to third-level)
        $('li.inner-menu2 > a').on('click', function (event) {
        const $li = $(this).parent('li');
        const $submenu = $li.children('div.third-level-menu');
        const $parentMenu = $li.closest('div.second-level-menu');

        if ($submenu.length > 0) {
            event.preventDefault();
            event.stopPropagation();

            // Hide sibling <li> items in second-level
            $li.siblings('li').css('display', "none");
            $li.css('display', "block"); // Keep the clicked one visible
            $li.siblings('li').css('pointer-events', 'none');

            // Show submenu
            $parentMenu.removeClass('close-menu');
            $submenu.addClass('open-menu').removeClass('close-menu');
            $submenu.scrollTop(0); // Ensure the submenu starts at the very top when opened
        }
        });
    }

    // popular brands row - mobile view
    $('.logo-brands-menu__mobile').each(function() {
        if (!$(this).find('img').length) {
        $(this).prev('.logo-brands-menu__header__mobile').addClass('hidden');
        }
    });
         
    $(".sticky-mega-nav--item").click(function() {
        document.querySelector(".js-mobile-menu-icon").click();
        $('body').addClass('menu-sticky mobile-menu-open');
    });

    $(window).scroll(function() {
        var sticky = $('.header--sticky'),
            scroll = $(window).scrollTop();

        if (scroll >= 50) {
            sticky.addClass('fixed');
            $('body').addClass('menu-sticky');
        } else {
            sticky.removeClass('fixed');
            $('body').removeClass('menu-sticky');
        }
    });

    $(".close-mobile-menu.js-close-mobile-menu").off().click(function() {
        $(".mobile--navigation .mobile-site-nav__icon").removeClass("submenu-open");
        $(".mobile-menu-nav--title .nav_svg").attr("src", "");
        $("body").removeClass("sub-menu-open");
        if ($('.header-nav-vertical li').hasClass('open')) {
            $('.header-nav-vertical li').removeClass('open');
        }
    });

    if ($(window).innerWidth() > 1024) {
        $('.mega-dropdown__item.grid__item').off().hover(function() {
            jQuery(".site-nav__submenu").hide();
            jQuery(".site-nav__submenu[data-id='" + jQuery(this).data('id') + "']").show();
        }, function() {
            if (!$(".new-nav-menu--sublinks:hover").length > 0) {
                jQuery(".site-nav__submenu[data-id='" + jQuery(this).data('id') + "']").hide();
            }
        });

    }

    $(".new_nav_search").click(function() {
        $(".search-bar--open.search-bar--open-mobile").show();
        $("body").addClass("open_search_bar");
        $(".new_nav_search").hide();
        // $(".search-bar__container .mobile-nav-logo").hide();
    });
    
    // $(".search-form__icon-close.new_nav_search_icon").click(function() {
    //     $(".search-bar--open.search-bar--open-mobile").hide();
    //     $("body").removeClass("open_search_bar");
    //     $(".new_nav_search, .mobile-search-form-focus").show();
    //     $('.mobile-serach-input').val('');
    //     searchValueIndex();
    // });

    function searchValueIndex() {
        let searchValue = document.querySelector(".mobile-serach-input").value;
        console.log(searchValue.length);
        if (searchValue.length > 0) {
            document.querySelector('.mobile-search').style.display = "block";
            document.querySelector('.mobile-search-form-focus').style.display = "none";
        } else {
            document.querySelector('.mobile-search').style.display = "none";
            document.querySelector('.mobile-search-form-focus').style.display = "block";
        }
    }


});